import 'angular:locale/data:en-US';
import '@angular/localize/init';
import 'core-js/modules/es.object.has-own.js';(globalThis.$localize ??= {}).locale = "en-US";
